import React, { useEffect, useState } from 'react';
import './CookieBanner.css';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const ADS_ID = 'ca-pub-XXXXXXXXXXXXX';

  const ensureDataLayer = () => {
    if (typeof window === 'undefined') return null;
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
  };

  const gtag = function () {
    const dataLayer = ensureDataLayer();
    if (dataLayer) dataLayer.push(arguments);
  };

  const loadAdSense = () => {
    if (!document.getElementById('adsense-script')) {
      const adScript = document.createElement('script');
      adScript.id = 'adsense-script';
      adScript.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADS_ID}`;
      adScript.async = true;
      adScript.crossOrigin = 'anonymous';
      document.head.appendChild(adScript);
    }
  };

  useEffect(() => {
    ensureDataLayer();
    const hasConsent = localStorage.getItem('offlist_cookie_consent');

    if (!hasConsent) {
      setShowBanner(true);
    } else if (hasConsent === 'true') {
      gtag('consent', 'update', {
        analytics_storage: 'granted',
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
      });
      loadAdSense();
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('offlist_cookie_consent', 'true');
    setShowBanner(false);
    gtag('consent', 'update', {
      analytics_storage: 'granted',
      ad_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
    });
    loadAdSense();
  };

  const declineCookies = () => {
    localStorage.setItem('offlist_cookie_consent', 'false');
    setShowBanner(false);
    gtag('consent', 'update', {
      analytics_storage: 'denied',
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
    });
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner-overlay">
      <div className="cookie-banner-content">
        <div className="cookie-text">
          <h4>Vi bruger cookies</h4>
          <p>
            Vi bruger cookies til at huske dine præferencer og forbedre din oplevelse.{' '}
            <a
              className="cookie-privacy-link"
              href="/PrivacyPolicy"
              style={{
                color: 'var(--btn-primary-text)',
                background: 'transparent',
                border: 'none',
                padding: 0,
                margin: 0,
                font: 'inherit',
                textDecoration: 'underline',
                textUnderlineOffset: '3px',
                textDecorationThickness: '1px',
              }}
            >
              Læs vores privatlivs- og cookiepolitik.
            </a>
          </p>
        </div>
        <div className="cookie-buttons">
          <button className="cookie-btn-decline" onClick={declineCookies} style={{ background: 'var(--btn-primary-bg)', color: 'var(--btn-primary-text)', border: 'none', padding: '8px 16px', cursor: 'pointer' }}>
            Afvis
          </button>
          <button className="cookie-btn-accept" onClick={acceptCookies} style={{ background: 'var(--btn-primary-bg)', color: 'var(--btn-primary-text)', border: 'none', padding: '8px 16px', cursor: 'pointer' }}>
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
